import React, { createContext, useContext, useState } from 'react';
import { node } from 'prop-types';
import { SCREEN_NAMES } from '../utils/constants';

const CorePricingContext = createContext({});

export function CorePricingContextProvider({ children }) {
   const [activeScreen, setActiveScreen] = useState(SCREEN_NAMES.FARES);
   const [showUploadModal, setIsShowUploadModal] = useState(null);
   const [user, setUser] = useState(null);

   const contextValues = {
      activeScreen,
      setActiveScreen,
      showUploadModal,
      setIsShowUploadModal,
      user,
      setUser,
   };

   return (
      <CorePricingContext.Provider value={contextValues}>
         {children}
      </CorePricingContext.Provider>
   );
}

export const useCorePricingContext = () => useContext(CorePricingContext);

CorePricingContextProvider.propTypes = {
   children: node,
};
